import { render, staticRenderFns } from "./EnrollIndex.vue?vue&type=template&id=c51ab5ce&scoped=true"
import script from "./EnrollIndex.vue?vue&type=script&lang=js"
export * from "./EnrollIndex.vue?vue&type=script&lang=js"
import style0 from "./EnrollIndex.vue?vue&type=style&index=0&id=c51ab5ce&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c51ab5ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c51ab5ce')) {
      api.createRecord('c51ab5ce', component.options)
    } else {
      api.reload('c51ab5ce', component.options)
    }
    module.hot.accept("./EnrollIndex.vue?vue&type=template&id=c51ab5ce&scoped=true", function () {
      api.rerender('c51ab5ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/enroll/EnrollIndex.vue"
export default component.exports